import { Row } from "antd";
import { styled } from "styled-components";

export const TotalInvoicesContainer = styled(Row)`
  margin-top: 8px;
  padding: 0 32px;
  .title {
    color: #001377;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
  }
  .radio {
    span {
      color: #001377;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
    }
  }
  .relatedInvoice {
    color: #001377;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
  }
  .invoice-base-info {
    color: #001377;
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    margin-top: 24px;
  }
  .formItem {
    label {
      color: #001377;
      font-size: 14px;
      font-style: normal;
      font-weight: 500;
      line-height: normal;
      height: unset;
    }
  }
  .footer {
    border-top: 1px solid #dadeec;
    padding-top: 32px;
    padding-bottom: 16px;
  }
  .attachFile {
    display: flex;
    padding: 16px 24px;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    gap: 24px;
    align-self: stretch;
    border-radius: 8px;
    border: 1px dashed #dadeec;
  }
  .attachFileLabel {
    color: var(--text, #001377);
    font-family: DM Sans;
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
  }
`;
